export const DIVISIONS = {
	RAIL: {
		label: 'Rail Technology and Services',
		to: '/rail-technology-services/',
	},
	DACE: {
		label: 'Data, Analytics, Consultancy and Events',
		to: '/data-analytics-consultancy-and-events/',
	},
};

export const BUSINESS_UNITS = {
	RAIL: {
		label: 'Rail Operations',
		tag: 'Rail Planning and Performance Software',
		to: 'https://tracsisops.com',
		uuid: 'a592c9d8-7829-4322-876a-920c3c564286',
	},
	BELLVEDI: {
		label: 'Bellvedi',
		tag: 'Timetable and Control Software',
		to: 'https://bellvedi.com',
	},
	IBLOCKS: {
		label: 'Transit and Ticketing',
		tag: 'Transit software solutions.',
		to: 'https://tracsis-iblocks.com',
		uuid: '23f199a2-eb34-436d-90e4-9c296c5742b3',
	},
	MPEC: {
		label: 'MPEC Technology',
		tag: 'Remote Condition Monitoring',
		to: 'https://mpec.co.uk',
		uuid: '16d325d7-5ce6-4a5f-b540-fd12af03ea47',
	},
	ONTRAC: {
		label: 'ONTRAC',
		tag: 'Rail Safety Software',
		to: 'https://on-trac.co.uk',
	},
	TRACSISUS: {
		label: 'Tracsis US',
		tag: 'Rail Technology Solutions',
		to: 'https://tracsis-us.com',
		uuid: 'e2605939-3e58-4311-841e-b4828550ab8b',
	},
	TRACSISUS_OP: {
		label: 'Tracsis US',
		tag: 'Computer Aided Dispatch',
		to: 'https://tracsis-us.com/solutions/computer-aided-dispatching/',
	},
	TRACSISUS_DR: {
		label: 'Tracsis US',
		tag: 'Yard Automation',
		to: 'https://tracsis-us.com/solutions/yard-automation/',
	},
	TRAFFICDATA: {
		label: 'Traffic Data',
		tag: 'Transport Data Collection and Analysis',
		to: 'https://tracsistraffic.com',
		uuid: 'e486c3a3-4c39-477f-9751-6630f4573907',
	},
	EVENTS: {
		label: 'Tracsis Events',
		tag: 'Event Traffic Management',
		to: 'https://tracsisevents.com',
		uuid: '92adc2cc-17f9-4383-af83-e0badb65cac7',
	},
	COMPASS: {
		label: 'Compass Informatics',
		tag: 'Information and Location Insights',
		to: 'https://compass.ie/',
	},
	ICON: {
		label: 'Tracsis Geo Intelligence',
		tag: 'Earth Observation',
		to: 'http://tracsis-geointelligence.com/',
	},
	CONSULTANCY: {
		label: 'Consultancy',
		tag: 'Insights and Bespoke Development',
		to: 'https://tracsisconsultancy.com/',
		uuid: '8a951812-95c2-42b3-9ee4-e308225585a8',
	},
};
